import React from "react";
import { Route, Navigate } from "react-router-dom";
const routes = all_routes;
import { all_routes } from "./all_routes";
//region icons
import FontawesomeIcons from "../feature-module/uiinterface/icons/fontawesome";
import FeatherIcons from "../feature-module/uiinterface/icons/feathericon";
import IonicIcons from "../feature-module/uiinterface/icons/ionicicons";
import MaterialIcons from "../feature-module/uiinterface/icons/materialicon";
import PE7Icons from "../feature-module/uiinterface/icons/pe7icons";
import SimplelineIcons from "../feature-module/uiinterface/icons/simplelineicon";
import ThemifyIcons from "../feature-module/uiinterface/icons/themify";
import WeatherIcons from "../feature-module/uiinterface/icons/weathericons";
import TypiconIcons from "../feature-module/uiinterface/icons/typicons";
import FlagIcons from "../feature-module/uiinterface/icons/flagicons";
import BootstrapIcons from "../feature-module/uiinterface/icons/bootstrapicons";
import RemixIcons from "../feature-module/uiinterface/icons/remixIcons";
import TablerIcon from "../feature-module/uiinterface/icons/tablericon";
import LayoutDemo from "../feature-module/layout-pages/layoutdemo";

//region auth
import Signin from "../feature-module/pages/login/signin";
import Forgotpassword from "../feature-module/pages/forgotpassword/forgotpassword";

//region Filter Management
import AssetManagement from "../feature-module/AssetMgt/AssetManagement";
import AssetPermissions from "../feature-module/AssetMgt/Admin/Permissions";
import AssetItems from "../feature-module/AssetMgt/Assets/AssetItems/FiltersList/Filters";
import AssetmgtUsers from "../feature-module/AssetMgt/Admin/Users/Users";
import AssetReports from "../feature-module/AssetMgt/Reports/Reports";
import AssetActivityLog from "../feature-module/AssetMgt/AuditLog/Assetactivitylog";
import AssetLandingpage from "../feature-module/AssetMgt/Landingpage/AssetLandingpage";
import UserPermissions from "../feature-module/AssetMgt/Admin/UserPermissions/UserPermissions";
import Schedule from "../feature-module/AssetMgt/Schedule/Schedule";
import ReplacementList from "../feature-module/AssetMgt/RelpacementList/ReplacementList";
import RetirementList from "../feature-module/AssetMgt/RetirementList/RetirementList";
import PasswordPolicies from "../feature-module/AssetMgt/Admin/PasswordPolicies";
import UserProfile from "../feature-module/AssetMgt/User/UserProfile";
import AlarmsDeviations from "../feature-module/AssetMgt/Alarms/AlarmsDeviations";
import RoleNotifications from "../feature-module/AssetMgt/Notifications/Notifications";
import BackUpRestore from "../feature-module/AssetMgt/BackupRestore/BackUpRestore";
import FilterHistoryReport from "../feature-module/AssetMgt/Reports/FilterHistoryReport";
import DryingReport from "../feature-module/AssetMgt/Reports/DryingReport";
import DryerEquip from "../feature-module/AssetMgt/Master/Equipments/Equipments";
import MaintenanceStages from "../feature-module/AssetMgt/Master/MaintenanceStages.jsx/MaintenanceStages";
import FunctionalLocations from "../feature-module/AssetMgt/Master/Blocks/Blocks";
import FilterTypes from "../feature-module/AssetMgt/Master/FilterTypes/FilterTypes";
import WashinReasons from "../feature-module/AssetMgt/Master/WashInReasons/WashinReasons";
import Approvals from "../feature-module/AssetMgt/Approvals/Approvals";
import MyTasks from "../feature-module/AssetMgt/MyTasks/MyTasks";
import BarcodeReport from "../feature-module/AssetMgt/Reports/BarcodeReport";
import AuditLogReport from "../feature-module/AssetMgt/Reports/AuditLogReport";
import FilterCleaningReport from "../feature-module/AssetMgt/Reports/FilterCleaningReport";
import DeviationsReport from "../feature-module/AssetMgt/Reports/DeviationsReport";
import LocationType from "../feature-module/AssetMgt/Master/LocationTypes/LocationType";
import UserRequests from "../feature-module/AssetMgt/User/UserRequests";
import FilterDryingCleaningReport from "../feature-module/AssetMgt/Reports/FilterDryingCleaningReport";
import RfidAssign from "../feature-module/AssetMgt/Assets/AssetItems/FiltersList/RfidAssign";

import Areas from "../feature-module/AssetMgt/Master/Areas/Areas";
import InspectionChecklistItems from "../feature-module/AssetMgt/Master/InspectionChecklistItems/InspectionChecklistItems";
import InspectionCheckList from "../feature-module/AssetMgt/Master/InspectionChecklist/InspectionCheckList";
import FiltersTree from "../feature-module/AssetMgt/Assets/AssetItems/FilterTree/FiltersTree";
import Queryss from "../feature-module/AssetMgt/QueryExecution/Query";
import AuditLogConfig from "../feature-module/AssetMgt/Config/AuditLogConfig";
import ChecklistReport from "../feature-module/AssetMgt/Reports/CheckListReport";

export const publicRoutes = [
  {
    id: 49,
    path: routes.fontawesome,
    name: "fontawesome",
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    id: 50,
    path: routes.feathericon,
    name: "feathericon",
    element: <FeatherIcons />,
    route: Route,
  },
  {
    id: 51,
    path: routes.ionicicons,
    name: "ionicicons",
    element: <IonicIcons />,
    route: Route,
  },
  {
    id: 52,
    path: routes.materialicons,
    name: "materialicons",
    element: <MaterialIcons />,
    route: Route,
  },
  {
    id: 53,
    path: routes.pe7icons,
    name: "pe7icons",
    element: <PE7Icons />,
    route: Route,
  },
  {
    id: 54,
    path: routes.simpleline,
    name: "simpleline",
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    id: 55,
    path: routes.themifyicons,
    name: "themifyicon",
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    id: 56,
    path: routes.iconweather,
    name: "iconweather",
    element: <WeatherIcons />,
    route: Route,
  },
  {
    id: 57,
    path: routes.typicons,
    name: "typicons",
    element: <TypiconIcons />,
    route: Route,
  },
  {
    id: 58,
    path: routes.flagicons,
    name: "flagicons",
    element: <FlagIcons />,
    route: Route,
  },
  {
    id: 106,
    path: routes.remixIcon,
    name: "remixIcon",
    element: <RemixIcons />,
    route: Route,
  },
  {
    id: 107,
    path: routes.BootstrapIcon,
    name: "BootstrapIcon",
    element: <BootstrapIcons />,
    route: Route,
  },
  {
    id: 108,
    path: routes.TablerIcon,
    name: "TablerIcon",
    element: <TablerIcon />,
    route: Route,
  },
  {
    id: 116,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 117,
    path: "/",
    name: "Root",
    element: <Navigate to="/signin" />,
    route: Route,
  },
  {
    id: 162,
    path: routes.Horizontal,
    name: "layout-horizontal",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 163,
    path: routes.Detached,
    name: "layout-detached",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 164,
    path: routes.Modern,
    name: "layout-modern",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 165,
    path: routes.TwoColumn,
    name: "layout-two-column",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 166,
    path: routes.Hovered,
    name: "layout-hovered",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 167,
    path: routes.Boxed,
    name: "layout-boxed",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 168,
    path: routes.RTL,
    name: "layout-rtl",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 169,
    path: routes.Dark,
    name: "layout-dark",
    element: <LayoutDemo />,
    route: Route,
  },

  {
    id: 700,
    path: routes.assetmgtdashboard,
    name: "assetmgtdashboard",
    element: <AssetManagement />,
    route: Route,
  },

  {
    id: 800,
    path: routes.assetmgtPermissions,
    name: "assetmgtPermissions",
    element: <AssetPermissions />,
    route: Route,
    isProtected: true,
  },

  {
    id: 802,
    path: routes.assetmgtAssetItems,
    name: "assetmgtAssetItems",
    element: <AssetItems />,
    route: Route,
    isProtected: true,
  },
  {
    id: 803,
    path: routes.assetmgtUsers,
    name: "assetmgtUsers",
    element: <AssetmgtUsers />,
    route: Route,
    isProtected: true,
  },

  {
    id: 805,
    path: routes.assetmgtreports,
    name: "assetmgtreports",
    element: <AssetReports />,
    route: Route,
    isProtected: true,
  },
  {
    id: 806,
    path: routes.assetactivitylog,
    name: "assetactivitylog",
    element: <AssetActivityLog />,
    route: Route,
    isProtected: true,
  },
  {
    id: 807,
    path: routes.assetmgtlandingpage,
    name: "assetmgtlandingpage",
    element: <AssetLandingpage />,
    route: Route,
    isProtected: true,
  },
  {
    id: 808,
    path: routes.assetmgtUserpermissions,
    name: "assetmgtUserpermissions",
    element: <UserPermissions />,
    route: Route,
    isProtected: true,
  },

  {
    id: 810,
    path: routes.assetmgtschedule,
    name: "assetmgtschedule",
    element: <Schedule />,
    route: Route,
    isProtected: true,
  },
  {
    id: 811,
    path: routes.assetmgtreplacementlist,
    name: "assetmgtreplacementlist",
    element: <ReplacementList />,
    route: Route,
    isProtected: true,
  },
  {
    id: 812,
    path: routes.assetmgtapprovals,
    name: "assetmgtapprovals",
    element: <Approvals />,
    route: Route,
    isProtected: true,
  },
  {
    id: 813,
    path: routes.assetmgtretirementlist,
    name: "assetmgtretirementlist",
    element: <RetirementList />,
    route: Route,
    isProtected: true,
  },
  {
    id: 814,
    path: routes.assetmgtPasswordpolices,
    name: "assetmgtPasswordpolices",
    element: <PasswordPolicies />,
    route: Route,
    isProtected: true,
  },
  {
    id: 815,
    path: routes.assetmgtUserAccount,
    name: "assetmgtUserAccount",
    element: <UserProfile />,
    route: Route,
    isProtected: true,
  },
  {
    id: 816,
    path: routes.assetmgtAlarmsDeviations,
    name: "assetmgtAlarmsDeviations",
    element: <AlarmsDeviations />,
    route: Route,
    isProtected: true,
  },
  {
    id: 817,
    path: routes.assetmgtNotifications,
    name: "assetmgtNotifications",
    element: <RoleNotifications />,
    route: Route,
    isProtected: true,
  },
  {
    id: 818,
    path: routes.assetmgtBackUpRestore,
    name: "assetmgtBackUpRestore",
    element: <BackUpRestore />,
    route: Route,
    isProtected: true,
  },
  {
    id: 819,
    path: routes.assetmgtFilterHistory,
    name: "assetmgtFilterHistory",
    element: <FilterHistoryReport />,
    route: Route,
  },
  {
    id: 820,
    path: routes.assetmgtdryreport,
    name: "assetmgtdryreport",
    element: <DryingReport />,
    route: Route,
  },
  {
    id: 821,
    path: routes.assetmgtdryerequip,
    name: "assetmgtdryerequip",
    element: <DryerEquip />,
    route: Route,
  },
  {
    id: 822,
    path: routes.assetmgtmaintenancestages,
    name: "assetmgtmaintenancestages",
    element: <MaintenanceStages />,
    route: Route,
  },
  {
    id: 823,
    path: routes.assetmgtfunctionallocations,
    name: "assetmgtfunctionallocations",
    element: <FunctionalLocations />,
    route: Route,
  },
  {
    id: 824,
    path: routes.assetmgtassettype,
    name: "assetmgtassettype",
    element: <FilterTypes />,
    route: Route,
  },
  {
    id: 825,
    path: routes.assetmgtwashinreasons,
    name: "assetmgtwashinreasons",
    element: <WashinReasons />,
    route: Route,
  },

  {
    id: 831,
    path: routes.assetmgtmytasks,
    name: "assetmgtmytasks",
    element: <MyTasks />,
    route: Route,
  },
  {
    id: 834,
    path: routes.assetmgtbarcodereport,
    name: "assetmgtbarcodereport",
    element: <BarcodeReport />,
    route: Route,
  },
  {
    id: 835,
    path: routes.assetmgtauditlogreport,
    name: "assetmgtauditlogreport",
    element: <AuditLogReport />,
    route: Route,
  },
  {
    id: 836,
    path: routes.assetmgtfiltercleaning,
    name: "assetmgtfiltercleaning",
    element: <FilterCleaningReport />,
    route: Route,
  },
  {
    id: 837,
    path: routes.assetmgtdeviationsreport,
    name: "assetmgtdeviationsreport",
    element: <DeviationsReport />,
    route: Route,
  },
  {
    id: 838,
    path: routes.assetmgtlocationtypes,
    name: "assetmgtlocationtypes",
    element: <LocationType />,
    route: Route,
  },
  {
    id: 839,
    path: routes.assetmgtUserRequests,
    name: "assetmgtUserRequests",
    element: <UserRequests />,
    route: Route,
  },
  {
    id: 840,
    path: routes.assetmgtFilterDryingCleaningReport,
    name: "assetmgtFilterDryingCleaningReport",
    element: <FilterDryingCleaningReport />,
    route: Route,
  },
  {
    id: 841,
    path: routes.assetmgtRfidAssign,
    name: "assetmgtRfidAssign",
    element: <RfidAssign />,
    route: Route,
  },
  {
    id: 842,
    path: routes.assetmgtInspectionChecklist,
    name: "assetmgtInspectionChecklist",
    element: <InspectionCheckList />,
    route: Route,
  },
  {
    id: 843,
    path: routes.assetmgtChecklistItems,
    name: "assetmgtChecklistItems",
    element: <InspectionChecklistItems />,
    route: Route,
  },
  {
    id: 844,
    path: routes.assetmgtAreas,
    name: "assetmgtAreas",
    element: <Areas />,
    route: Route,
  },
  {
    id: 845,
    path: routes.assetmgtFiltersTree,
    name: "assetmgtFiltersTree",
    element: <FiltersTree />,
    route: Route,
  },
  {
    id: 845,
    path: routes.assetmgtQuery,
    name: "assetmgtQuery",
    element: <Queryss />,
    route: Route,
  },
  {
    id: 845,
    path: routes.assetmgtConfigAudit,
    name: "assetmgtConfigAudit",
    element: <AuditLogConfig />,
    route: Route,
  },
  {
    id: 846,
    path: routes.assetmgtChecklistReport,
    name: "assetmgtChecklistReport",
    element: <ChecklistReport />,
    route: Route,
  }
];

export const posRoutes = [];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },

  {
    id: 7,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <Forgotpassword />,
    route: Route,
  },
];
